import { post } from "./lib/api"

export function createSsoCallbackUrl(callbackUrl, urlOption, ssoOptions) {
  let ssoCallbackUrl = callbackUrl
  const params = $.param(
    Object.assign(
      urlOption || {},
      ssoOptions && { applet_id: ssoOptions.appletId },
      ssoOptions && { service_slug: ssoOptions.serviceSlug }
    )
  )
  if (params.length) {
    ssoCallbackUrl += (callbackUrl.includes("?") ? "&" : "?") + params
  }
  return ssoCallbackUrl
}

export async function appleSSO(
  callbackUrl,
  urlOption,
  ssoOptions,
  callbackOptions = {}
) {
  const ssoCallbackUrl = createSsoCallbackUrl(
    callbackUrl,
    urlOption,
    ssoOptions
  )

  try {
    const data = await AppleID.auth.signIn()
    return post(ssoCallbackUrl, { ...data.authorization, ...callbackOptions })
  } catch (error) {
    throw new Error("Your Apple ID authentication failed.")
  }
}

export function googleSSO(
  callbackUrl,
  urlOption,
  ssoOptions,
  callbackOptions = {}
) {
  const ssoCallbackUrl = createSsoCallbackUrl(
    callbackUrl,
    urlOption,
    ssoOptions
  )

  return new Promise((resolve, reject) =>
    gapi.auth2.authorize(
      {
        response_type: "code",
        cookie_policy: "single_host_origin",
        client_id: window.App.googleAppKey,
        scope: "email profile",
      },
      function (response) {
        if (response && !response.error) {
          resolve(post(ssoCallbackUrl, { ...response, ...callbackOptions }))
        } else {
          if (response?.error === "idpiframe_initialization_failed") {
            // Likely 3rd-party cookies are disabled, an unfortunate requirement.
            // Fall back gracefully to (less-secure) redirect auth:
            const googleAuthRedirectUrl =
              "https://accounts.google.com/o/oauth2/auth?" +
              $.param({
                access_type: "offline",
                client_id: window.App.googleAppKey,
                redirect_uri: ssoCallbackUrl,
                response_type: "code",
                scope: "email profile",
              })
            location.assign(googleAuthRedirectUrl)
            return resolve({})
          }

          const ssoErrorMessage = "Google could not verify your account."

          reject(new Error(ssoErrorMessage))
        }
      }
    )
  )
}

export function facebookSSO(
  callbackUrl,
  urlOption,
  ssoOptions,
  callbackOptions = { fbReauth: null }
) {
  const ssoCallbackUrl = createSsoCallbackUrl(
    callbackUrl,
    urlOption,
    ssoOptions
  )
  const opts = { scope: "email" }
  if (callbackOptions.fbReauth) {
    opts.auth_type = "rerequest"
  }
  delete callbackOptions.fbReauth

  return new Promise((resolve, reject) =>
    FB.login(function (response) {
      if (response.authResponse) {
        resolve(post(ssoCallbackUrl, callbackOptions))
      } else {
        const ssoErrorMessage = "Facebook could not verify your account."

        reject(new Error(ssoErrorMessage))
      }
    }, opts)
  )
}
